import React, { Component } from 'react';

import classnames from 'classnames';
import CircularProgress from '@mui/material/CircularProgress';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { WithStyles, withStyles } from '@mui/styles';

import APButton from '../../atoms/APButton';
import APInput from './../../atoms/APInput';
import APLabel from '../../atoms/APLabel';
import APSelect from '../../atoms/APSelect';
import APAlertMessage from '../../atoms/APAlertMessage';
import { actions as AddressLookupActions } from './../../../redux/modules/address';
import { ReducerState } from './../../../redux/modules';
import { withTranslate } from '../../../core/TenantProvider';

import APAddressLookupStyles from './styles/APAddressLookup.style';
import { getUSAStateDetails } from "../../../core/utils/MappingForUSAStates";
import { ReactComponent as IconChevronRight } from './assets/icon-chevron-right.svg';
import { MASK_CLASS } from '../../../core/utils/Constants/Constants';

interface APAddressLookupProps extends WithStyles<typeof APAddressLookupStyles> {
	addressRetrieve: Function,
	addressSearch: Function,
	additionalAddressSearch: Function,
	clearAddressResults: Function,
	label?: Function,
	onBlur?: Function,
	onChange?: Function,
	onFocus?: Function,
	name?: string,
	retrieve?: any,
	jointRetrieve?: any,
	search?: any,
	jointSearch?: any,
	translate: Function,
	value: any,
	selectedValues: any,
	isJoint: boolean,
	isRegistration: boolean,
	error: any,
	helper: any,
	isCoralogixMasked?: boolean
}

class APAddressLookup extends Component<APAddressLookupProps, {}> {
	state = {
		address: {
			country: '',
			line1: '',
			city: '',
			county: '',
			postcode: '',
			categoryOfUSAState: ''
		},
		error: {},
		helper: {},
		isEditing: false,
		isFocused: false,
		selectedIndex: -1,
		showManualLookUp: false,
		showManualLookupJoint: false,
		showErrorMessage: false
	};

	static getDerivedStateFromProps(props: APAddressLookupProps, state: any) {
		const isManualEntry = state.isEditing;
		if (props.value && !isManualEntry) {
			return {
				...state,
				address: props.value
			};
		}

		return state;
	}

	private myRef;
	constructor(props: APAddressLookupProps) {
		super(props);
		this.myRef = React.createRef();
		this.onBlur = this.onBlur.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onFocus = this.onFocus.bind(this);
		this.calculateNewIndex = this.calculateNewIndex.bind(this);
		this.onKeyUp = this.onKeyUp.bind(this);
		this.onManualChange = this.onManualChange.bind(this);
		this.onManualEntryClick = this.onManualEntryClick.bind(this);
		this.onCountryOrManualBlur = this.onCountryOrManualBlur.bind(this);

		this.onChangeCountry = this.onChangeCountry.bind(this);
	}

	isFieldValid(field: string, value: any) {
		let isValid: boolean = true;
		let currentVal: any = value;
		let { error } = this.state;

		switch (field) {
			case 'country':
				isValid = currentVal && currentVal.trim() !== '';
				break;
			case 'line1':
				isValid = /^[^\s].{1,254}$/.test(currentVal.trim());
				break;
			case 'city':
				isValid = /^[^\s].{0,39}$/.test(currentVal.trim());
				break;
			case 'county':
				isValid = /^[^\s].{0,79}$/.test(currentVal.trim());
				break;
			case 'postcode':
				isValid = /^[0-9a-zA-Z- ]{3,20}$/.test(currentVal.trim());
				break;
		}

		error[field] = (!isValid);
		this.setState({
			error
		});
		return isValid;
	}

	onCountryOrManualBlur(evt: any) {
		const {
			target: {
				name,
				value
			}
		} = evt;

		this.setState({
			isFocused: false
		}, () => {
			this.isFieldValid(name, value);
		});
	}

	onBlur(evt: any) {
		const {
			onBlur,
			name
		} = this.props;

		this.setState({
			isFocused: false
		}, () => {
			if (onBlur) {
				onBlur({
					target: {
						name
					}
				});
			}
		});
	}

	onChange(evt: any) {
		const {
			addressSearch,
			isJoint
		} = this.props;

		const value = evt.target.value;
		this.setState({
			selectedIndex: -1
		}, () => {
			addressSearch(value, this.state.address.country, isJoint);
		});
	}

	onChangeCountry(evt: React.ChangeEvent<any>) {
		const { target: { value } } = evt;

		const {
			clearAddressResults,
			name,
			isJoint,
			onChange
		} = this.props;

		const address: any = {
			...this.state.address,
			country: value,
			line1: '',
			city: '',
			county: '',
			postcode: '',
			categoryOfUSAState: ''
		};
		const error = !address.country;

		this.setState(
			{
				address: address,
				showErrorMessage: false,
				error: { ...this.state.error, country: error }
			},
			() => {
				if (this.state.isEditing) {
					this.setState({ isEditing: false });
				} else {
					clearAddressResults({ isJoint });
				}

				if (onChange) {
					onChange({ target: { name, value: address } });
				}
			}
		);
	}

	onFocus(evt: any) {
		const {
			onFocus
		} = this.props;

		this.setState({
			isFocused: true
		}, () => {
			if (onFocus) {
				onFocus(evt);
			}
		});
	}

	calculateNewIndex(keyCode: number, currentIndex: number, results: string | any[]) {
		const validResults = results || [];
		let newIndex = currentIndex;

		if (keyCode === 38) {
			newIndex -= 1;
		} else if (keyCode === 40) {
			newIndex += 1;
		}

		if (newIndex >= validResults.length) {
			newIndex = -1;
		} else if (newIndex < -1) {
			newIndex = validResults.length - 1;
		}

		return newIndex;
	}

	onKeyUp(evt: any) {
		const {
			search,
			jointSearch,
			isJoint
		} = this.props;

		const { keyCode } = evt;

		const results = isJoint ? jointSearch.results : search.results;
		const selectedIndex = this.calculateNewIndex(keyCode, this.state.selectedIndex, results);

		if (keyCode === 13) {
			const selectedItem = results[selectedIndex];
			if (selectedItem) {
				this.onSelect(selectedItem);
			}
		} else {
			this.setState({ selectedIndex });
		}
	}

	onManualChange(evt: any) {
		const {
			target: {
				name: field,
				value
			}
		} = evt;

		let selectedUSAState;
		if (this.state.address.country === 'USA' && field === 'county') {
			selectedUSAState = getUSAStateDetails(value);
		}
		const address: any = {
			...this.state.address,
			showErrorMessage: false,
			[field]: value,
			categoryOfUSAState: selectedUSAState?.category ? selectedUSAState?.category : this.state.address.categoryOfUSAState
		};

		this.setState({
			address
		}, () => {
			const {
				name,
				onChange
			} = this.props;

			if (onChange) {
				onChange({
					target: {
						name,
						value: address
					}
				});
			}
			this.isFieldValid(field, value);
		});
	}

	onManualEntryClick() {
		this.setState({
			isEditing: true
		});
	}

	onAddressUnavailable(result: any) {
		const {
			isJoint
		} = this.props;

		if (!result.Items[0] || Object.values(result.Items[0]).indexOf("1001") >= 0) {
			this.setState({
				showManualLookUp: isJoint ? this.state.showManualLookUp : true,
				showManualLookUpJoint: isJoint ? true : this.state.showManualLookupJoint,
				showErrorMessage: true
				// isEditing: false
			})
		} else {
			this.setState({
				showManualLookUp: isJoint ? this.state.showManualLookUp : false,
				showManualLookupJoint: isJoint ? false : this.state.showManualLookupJoint
			})
		}
	}

	onSelect(entry: any) {
		const {
			addressRetrieve,
			additionalAddressSearch,
			name,
			onChange,
			isJoint
		} = this.props;

		const {
			country
		} = this.state.address;

		if (entry && entry.Id && entry.Type) {
			const { Text, Id } = entry;
			if (entry.Type === "Address") {
				addressRetrieve(entry.Id, isJoint)
					.then((result: any) => {
						const selection: any = result && result.Items && result.Items[0];
						// This function will execute the logic when address search API response is empty
						this.onAddressUnavailable(result);

						if (selection) {
							let address: any = {};
							let hasResults: any = null;
							let selectedLineText: string = selection.Line1 ? (!selection.Line2) ? (selection.Line1) : (selection.Line1 + ', ' + selection.Line2) : ''

							if (this.state.address.country === 'USA') {
								const provinceName: string = selection.ProvinceName,
									selectedUSAState = getUSAStateDetails(provinceName);

								if (selectedUSAState !== undefined) {
									address = {
										...this.state.address,
										line1: selectedLineText,
										city: selection.City,
										county: selection.ProvinceName ? selection.ProvinceName : "",
										state: selection.ProvinceName ? selection.ProvinceName : "",
										postcode: selection.PostalCode,
										categoryOfUSAState: selectedUSAState?.category
									};
									hasResults = (!selection.Line1 || !selection.City || !selection.PostalCode || !selection.ProvinceName);
								} else {
									address = {
										...this.state.address,
										line1: selectedLineText,
										city: selection.City,
										county: "",
										state: "",
										postcode: selection.PostalCode
									};
									this.setState({
										error: {
											...this.state.error,
											county: true
										}
									});
									hasResults = true;
								}

							} else {
								address = {
									...this.state.address,
									line1: selectedLineText,
									city: selection.City,
									county: selection.ProvinceName ? selection.ProvinceName : "",
									state: selection.ProvinceName ? selection.ProvinceName : "",
									postcode: selection.PostalCode
								};
								hasResults = (!selection.Line1 || !selection.City || !selection.PostalCode || !selection.ProvinceName);
							}
							this.setState({
								showErrorMessage: hasResults,
								showManualLookUp: hasResults,
								showManualLookupJoint: (isJoint && hasResults),
								isEditing: hasResults,
								address
							}, () => {
								if (onChange) {
									onChange({
										target: {
											name,
											value: address
										}
									});
								}
								let isAnyFieldInvalid: boolean = false;
								Object.keys(address).forEach((key: string) => {
									let isValid = this.isFieldValid(key, address[key]);
									if (!isValid) {
										isAnyFieldInvalid = true;
									}
								});
								if (isAnyFieldInvalid) {
									this.setState({
										address,
										isEditing: true
									});
								}
							});
						}
					});
			} else {
				additionalAddressSearch(Text, country, Id, isJoint).then((response: any) => {
					// This function will execute the logic when address search API response is empty
					this.onAddressUnavailable(response);
					response.Items.length > 0 && this.myRef.current.focus();
				});
			}
		}
	}

	render() {
		const {
			classes,
			label,
			retrieve,
			jointRetrieve,
			search,
			jointSearch,
			translate,
			isJoint,
			isRegistration,
			selectedValues,
			isCoralogixMasked = false
		} = this.props;

		const countryType = (isRegistration) ? 'country_excl' : 'country';
		const showErrorMessage = this.state.showErrorMessage;
		const isManualEntry = this.state.isEditing;
		const showManualLookUp = this.state.showManualLookUp;
		const hasResults = isJoint ? (jointSearch && jointSearch.results && this.state.isFocused) :
			(search && search.results && this.state.isFocused);
		const hasSelection = isJoint ? (jointRetrieve && jointRetrieve.results && jointRetrieve.results.length) :
			(retrieve && retrieve.results && retrieve.results.length);

		const containerCls = classnames(classes.lookupContainer, {
			[classes.lookupContainerFocused]: hasResults && !hasSelection,
			[classes.lookupContainerSelected]: hasSelection
		});

		const isLoading = isJoint ? (jointSearch.loadingState === 'LOADING' || jointRetrieve.loadingState === 'LOADING') :
			(search.loadingState === 'LOADING' || retrieve.loadingState === 'LOADING');

		const hasSelectedValues = !!(selectedValues.country && selectedValues.line1 && selectedValues.city && selectedValues.county && selectedValues.postcode);

		const error: any = this.state.error || {};
		if (hasSelection || isManualEntry || hasSelectedValues) {
			const address: any = this.state.address || {};
			return (
				<div className={containerCls}>

					{/* Error message */}
					{showErrorMessage &&
						<APAlertMessage
							className={`errorMessage`}
							title={translate("global.addressLookup.error.title")}
							message={translate('global.addressLookup.error.message')}
							severity={"error"}
							icon={'error'}
							hideCloseIcon={false}
						/>
					}

					<APSelect
						className={classes.manualInput}
						label={translate('address.lookup.country.label')}
						name="country"
						onChange={this.onChangeCountry}
						type={countryType}
						value={this.state.address.country}
						onBlur={this.onCountryOrManualBlur}
						error={error.country}
						isCoralogixMasked={isCoralogixMasked}
					/>

					{!isManualEntry && hasSelectedValues &&
						<div className={classes.selectionSummary}>
							<APLabel className={classes.summaryLabel}>{translate('address.lookup.selection.summary.label')}</APLabel>
							<APLabel>
								<APLabel className={isCoralogixMasked ? MASK_CLASS : ''}>{address.line1}</APLabel>
								<APLabel className={isCoralogixMasked ? MASK_CLASS : ''}>{address.city}, {address.county}, {address.postcode}</APLabel>
							</APLabel>
							<APButton className={classes.textButton} onClick={this.onManualEntryClick} color="primary">
								{translate('address.lookup.selection.edit.label')}
							</APButton>
						</div>
					}

					{isManualEntry || ((showManualLookUp || !hasSelectedValues) && (this.state.address?.country?.length > 0)) ? (
						<div className={classes.manualEntryContainer}>

							{/* Required field */}
							<APInput
								className={classes.manualInput}
								label={translate('address.lookup.line1.label')}
								onChange={this.onManualChange}
								onBlur={this.onCountryOrManualBlur}
								name="line1"
								value={address.line1}
								error={error.line1}
								helperText={(error.line1) ? translate('address.lookup.line1.label.error') : ''}
								isCoralogixMasked={isCoralogixMasked}
							/>

							{/* Optional field */}
							<APInput
								className={classes.manualInput}
								label={translate('address.lookup.city.label')}
								onChange={this.onManualChange}
								onBlur={this.onCountryOrManualBlur}
								name="city"
								value={address.city}
								error={error.city}
								helperText={(error.city) ? translate('address.lookup.city.label.error') : ''}
								isCoralogixMasked={isCoralogixMasked}
							/>
							{this.state.address?.country === 'USA' ? (
								/* Required field */
								<APSelect
									className={classnames(classes.manualInput, classes.countySelect)}
									label={translate('address.lookup.county.label')}
									name="county"
									onChange={this.onManualChange}
									type="statesOfUSA"
									value={this.state.address.county}
									onBlur={this.onCountryOrManualBlur}
									error={error.county}
									helperText={(error.county) ? translate('address.lookup.county.label.error') : ''}
								/>
							) : (
								/* Required field */
								<APInput
									className={classes.manualInput}
									label={translate('address.lookup.county.label')}
									onChange={this.onManualChange}
									onBlur={this.onCountryOrManualBlur}
									name="county"
									value={address.county}
									error={error.county}
									helperText={(error.county) ? translate('address.lookup.county.label.error') : ''}
									isCoralogixMasked={isCoralogixMasked}
								/>
							)}

							{/* Required field */}
							<APInput
								className={classes.manualInput}
								label={translate('address.lookup.postcode.label')}
								onChange={this.onManualChange}
								onBlur={this.onCountryOrManualBlur}
								name="postcode"
								value={address.postcode}
								error={error.postcode}
								helperText={(error.postcode) ? translate('address.lookup.postcode.label.error') : ''}
								isCoralogixMasked={isCoralogixMasked}
							/>
						</div>
					) : null}
				</div>
			);
		}

		let searchResults = isJoint ? (jointSearch.results) : (search.results);
		searchResults = searchResults ? searchResults.filter((result: any) => (result.Text?.length > 0)) : [];

		return (
			<div className={containerCls} data-testid="ap-address-lookup">

				{/* Error message */}
				{showErrorMessage &&
					<APAlertMessage
						className={`errorMessage`}
						title={translate("global.addressLookup.error.title")}
						message={translate('global.addressLookup.error.message')}
						severity={"error"}
						icon={'error'}
						hideCloseIcon={true}
					/>
				}

				<APSelect
					className={classes.manualInput}
					label={translate('address.lookup.country.label')}
					name="country"
					onBlur={this.onCountryOrManualBlur}
					onChange={this.onChangeCountry}
					type={countryType}
					error={error.country}
					value={this.state.address.country}
				/>
				<div className="autocomplete">
					{this.state.address.country !== "" &&
						<APInput
							className={classes.lookupInput}
							label={label}
							onBlur={this.onBlur}
							onChange={this.onChange}
							onFocus={this.onFocus}
							onKeyUp={this.onKeyUp}
							inputProps={{
								autoComplete: 'new-address' + (isJoint) ? '-1' : '',
								form: {
									autocomplete: 'off',
								}
							}}
							inputRef={this.myRef}
						/>
					}
					{isLoading && <CircularProgress className={classes.loadingIcon} size={25} />}
					<APButton
						className={classes.textButton}
						onClick={this.onManualEntryClick}
						color="primary"
					>
						{translate('address.lookup.manualentry.label')}
					</APButton>
					{hasResults && searchResults?.length > 0 &&
						(<ul className={classes.lookupResults}>
							{
								searchResults.map((result: any, itemIndex: number) => {

									const textHtml = (result.Text) ? result.Text + ', ' : '';
									const descHtml = (result.Description) ? result.Description : '';
									const itemCls = classnames(classes.lookupResultsItem, {
										[classes.lookupResultsItemSelected]: this.state.selectedIndex === itemIndex
									});

									const onClick = () => {
										this.onSelect(result);
									}
									const searchAddressText = (
										<>
											{textHtml} {(descHtml === 'Text or Container Required') ? translate('address.lookup.search.no.result.found.text.label') : descHtml}
										</>
									);

									const multipleAddress = (
										<>
											<span>{searchAddressText}</span>
											<span> {<IconChevronRight />} </span>
										</>);

									const singleAddress = (
										<>
											{searchAddressText}
										</>);

									return result.Text?.length > 0 && (
										<li key={result.Id} className={itemCls} onMouseDown={onClick}>
											{result.Type !== 'Address' ? multipleAddress : singleAddress}
										</li>
									);
								})}
						</ul>)
					}
				</div>
			</div>
		);
	}
}

const mapStateToProps = (store: ReducerState) => ({
	retrieve: store.address.retrieve,
	search: store.address.search,
	jointRetrieve: store.address.jointRetrieve,
	jointSearch: store.address.jointSearch
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
	addressRetrieve: AddressLookupActions.addressRetrieve,
	addressSearch: AddressLookupActions.addressSearch,
	additionalAddressSearch: AddressLookupActions.additionalAddressSearch,
	clearAddressResults: AddressLookupActions.clearAddressResults
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(
	withTranslate(
		withStyles(APAddressLookupStyles)(APAddressLookup)
	)
);
